import makeDebug from 'debug'
import { getExtraFacets } from '@libs/utils/url'

import {
  getFiltersAndProducts,
  getPlpFilteredCMSBanners,
  getPlpProductsPayloadOptions,
  getProductsVariants,
  plpAnalytics,
} from '@libs/wcs/plp'

import { getWishlistProducts } from '@libs/wcs/wishlist'
import {
  UPDATE_ADD_REMOVE_FAVORITE,
  UPDATE_EXTRAFACETS,
  UPDATE_FACETS,
  UPDATE_FACETS_COUNT,
  UPDATE_FILTER_CATEGORY_LABEL,
  UPDATE_FILTERED_CMS_BANNERS,
  UPDATE_IDS_FILTERS_CHECKED,
  UPDATE_IS_FACETS_FIRST_LOAD,
  UPDATE_LOAD_PLP_FACETS,
  UPDATE_LOAD_PLP_PRODUCTS,
  UPDATE_LOAD_PLP_PRODUCTS_VARIANTS,
  UPDATE_NEXT_PAGE_URL,
  UPDATE_REMOVE_FACET_COUNT,
  UPDATE_RESET_PAGINATION_DATA,
  UPDATE_RETRIEVE_FAVORITE_LIST,
  UPDATE_UI,
  UPDATE_UI_BODY,
  UPDATE_URL,
} from '../mutations/plp'
import isEmpty from 'lodash/isEmpty'
import { getAlgoliaPlpProductsNormalized } from '@libs/algolia-normalizer'
import qs from 'qs'

const debug = makeDebug('store:action')

export const ACTION_LOAD_PLP = 'ACTION_LOAD_PLP'
export const ACTION_LOAD_PLP_PRODUCTS = 'ACTION_LOAD_PLP_PRODUCTS'
export const ACTION_LOAD_PLP_FACETS = 'ACTION_LOAD_PLP_FACETS'
export const ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT = 'ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT'
export const ACTION_TOGGLE_PLP_FILTER = 'ACTION_TOGGLE_PLP_FILTER'
export const ACTION_UPDATE_FACETS = 'ACTION_UPDATE_FACETS'
export const ACTION_LOAD_MORE = 'ACTION_LOAD_MORE'
export const ACTION_TOGGLE_SIDEBAR = 'ACTION_TOGGLE_SIDEBAR'
export const ACTION_UPDATE_FILTER_CATEGORY_LABEL = 'ACTION_UPDATE_FILTER_CATEGORY_LABEL'
export const ACTION_TOGGLE_FILTER_ITEM = 'ACTION_TOGGLE_FILTER_ITEM'
export const ACTION_UPDATE_IDS_FILTERS_CHECKED = 'ACTION_UPDATE_IDS_FILTERS_CHECKED'
export const ACTION_REMOVE_FACET_COUNT = 'ACTION_REMOVE_FACET_COUNT'
export const ACTION_UPDATE_FILTERED_CMS_BANNERS = 'ACTION_UPDATE_FILTERED_CMS_BANNERS'
export const ACTION_RETRIEVE_FAVORITE_LIST = 'ACTION_RETRIEVE_FAVORITE_LIST'
export const ACTION_ADD_REMOVE_FAVORITE = 'ACTION_ADD_REMOVE_FAVORITE'

export const actions = {
  //action triggered only on first page load:
  [ACTION_LOAD_PLP]: async function ({ commit, dispatch, state }) {
    const currentUrlParams = qs.parse(decodeURIComponent(window.location.search), {
      ignoreQueryPrefix: true,
    })
    const plpIsExploded = state.ui.plpIsExploded
    //save in state extra facets from url which are not selectable in ui but needs to be stored
    const extraFacets = getExtraFacets()
    let checkedFilters = []
    await commit(UPDATE_EXTRAFACETS, extraFacets)

    // first retrieve data from filters because they contain the orderBy clause
    debug('%s payload %o', ACTION_LOAD_PLP)
    await commit(UPDATE_UI, { plpLoadingFacets: true })

    const {
      facetParams,
      facetsDashList,
      facetsToggleList,
      facetsWithoutDashList,
      filterOptionsList,
      facetToSelect,
      sortOptionsList,
      numResult,
      hits,
      page,
      hitsPerPage,
      nbPages,
      nbHits,
      objectIDs,
      index,
      queryID,
      isSearch,
    } = await getFiltersAndProducts({
      extraFacets,
      plpIsExploded,
      currentPage: parseInt(currentUrlParams.currentPage) || 1,
      orderBy: currentUrlParams?.orderBy || 'default',
      currentProductsCount: state.products.length,
    })
    // create facet for the panel on right, sort option list
    commit(UPDATE_LOAD_PLP_FACETS, {
      facetsDashList,
      facetsToggleList,
      facetsWithoutDashList,
      filterOptionsList,
      sortOptionsList,
      numResult,
    })
    // add the query parameter (if present) to initialize vue state
    commit(UPDATE_FACETS, facetParams)
    // add the check to filters that should be selected
    facetToSelect.forEach(f => {
      checkedFilters.push(f.id)
      commit(UPDATE_IDS_FILTERS_CHECKED, f)
    })
    if (checkedFilters.length > 0)
      getPlpFilteredCMSBanners({
        filters: filterOptionsList,
        checkedFilters,
      }).then(data => dispatch(ACTION_UPDATE_FILTERED_CMS_BANNERS, data))
    await commit(UPDATE_UI, { plpLoadingFacets: false })
    const productsData = {
      hits,
      page,
      hitsPerPage,
      nbPages,
      nbHits,
      plpIsExploded,
      objectIDs,
      indexName:index,
      queryID,
      isSearch,
    }
    if (!isEmpty(productsData)) {
      const { options } = await getPlpProductsPayloadOptions({ ...state.facetsSelected })
      plpAnalytics(productsData) //todo move after LCP?
      const data = getAlgoliaPlpProductsNormalized(productsData)
      commit(UPDATE_LOAD_PLP_PRODUCTS, { ...data })
      commit(UPDATE_RESET_PAGINATION_DATA, { ...data }) //#SGHDP-9070 pagination data are altered at first load if currentPage>1
      commit(UPDATE_NEXT_PAGE_URL, { ...data })
      commit(UPDATE_UI, {
        plpLoadingProducts: false,
        plpLoadingMoreProducts: false,
        mobileView: state.ui.mobileView ? state.ui.mobileView : data.mobileView,
      })
      commit(UPDATE_URL, { ...state.facetsSelected })
      if (!state.isFacetsFirstLoad) {
        commit(UPDATE_IS_FACETS_FIRST_LOAD, true)
        commit(UPDATE_FACETS_COUNT, { filterOptionsList })
      }
      if (!plpIsExploded) {
        const productsAndVariants = await getProductsVariants({ productsData, options })
        await commit(UPDATE_LOAD_PLP_PRODUCTS_VARIANTS, { ...productsAndVariants })
      }
    }
    dispatch(ACTION_RETRIEVE_FAVORITE_LIST)
  },
  [ACTION_UPDATE_FACETS]: function (
    { dispatch, commit, state },
    { override, updateUi, clearUrl, ...payload }
  ) {
    debug('%s payload %o', ACTION_UPDATE_FACETS, payload)
    commit(UPDATE_FACETS, payload)
    dispatch(ACTION_LOAD_PLP_PRODUCTS, { override, updateUi, clearUrl, ...state.facetsSelected })
    dispatch(ACTION_LOAD_PLP_FACETS)
  },
  //action triggered at any page products update (applying filters, load more):
  [ACTION_LOAD_PLP_PRODUCTS]: async function (
    { commit, dispatch, state },
    { override, updateUi, clearUrl, ...payload }
  ) {
    const plpIsExploded = state.ui.plpIsExploded
    if (updateUi) {
      await commit(UPDATE_UI, updateUi)
    }
    debug('%s payload %o', ACTION_LOAD_PLP_PRODUCTS, payload)
    //add extraFacets to payload so they can be evaluated while fetching products
    payload.plpIsExploded = plpIsExploded
    const allFacets = state.facets.filterOptionsList
    const currentProductsCount = state.products.length
    if (payload.idsFiltersCheckedList.length > 0) {
      getPlpFilteredCMSBanners({
        filters: allFacets,
        checkedFilters: payload.idsFiltersCheckedList,
      }).then(data => dispatch(ACTION_UPDATE_FILTERED_CMS_BANNERS, data))
    } else {
      await dispatch(ACTION_UPDATE_FILTERED_CMS_BANNERS, '')
    }
    const { hits, page, hitsPerPage, nbPages, nbHits } = await getFiltersAndProducts({
      ...payload,
      currentProductsCount,
    })

    const productsData = {
      hits,
      hitsPerPage,
      nbPages,
      nbHits,
      plpIsExploded,
      page,
    }
    if (plpIsExploded) {
      const data = getAlgoliaPlpProductsNormalized(productsData)
      commit(UPDATE_LOAD_PLP_PRODUCTS, { ...data, override })
    } else {
      const { options } = await getPlpProductsPayloadOptions({ ...state.facetsSelected })
      const productsAndVariants = await getProductsVariants({ productsData, options })
      commit(UPDATE_LOAD_PLP_PRODUCTS, { ...productsAndVariants, override })
    }
    commit(UPDATE_UI, { plpLoadingProducts: false, plpLoadingMoreProducts: false })
    commit(UPDATE_URL, { clearUrl, ...payload })
  },
  [ACTION_LOAD_PLP_FACETS]: async function ({ commit, state }) {
    // eslint-disable-next-line no-unused-vars
    const plpIsExploded = state.ui.plpIsExploded
    const { currentPage, ...payload } = state.facetsSelected
    const currentProductsCount = state.products.length
    commit(UPDATE_UI, { plpLoadingFacets: true })
    debug('%s payload %o', ACTION_LOAD_PLP_FACETS, payload)
    //add extraFacets to payload so they can be evaluated while fetching facets
    payload.extraFacets = state.facetsSelected.extraFacets
    payload.plpIsExploded = plpIsExploded
    payload.currentPage = parseInt(currentPage) || 1 //default to 1 if not set
    const {
      facetsDashList,
      facetsToggleList,
      facetsWithoutDashList,
      filterOptionsList,
      sortOptionsList,
      numResult } = await getFiltersAndProducts({ ...payload, currentProductsCount })

    commit(UPDATE_LOAD_PLP_FACETS, {
      facetsDashList,facetsToggleList,facetsWithoutDashList,filterOptionsList,sortOptionsList,numResult,
    })
    if (!state.isFacetsFirstLoad) {
      await commit(UPDATE_IS_FACETS_FIRST_LOAD, true)
    }
    await commit(UPDATE_UI, { plpLoadingFacets: false })
  },
  [ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT]: function ({ commit, state }) {
    debug('action %o', ACTION_TOGGLE_PLP_LOADING_MORE_PRODUCT)
    commit(UPDATE_UI, { plpLoadingMoreProducts: !state.ui.plpLoadingProducts })
  },
  [ACTION_TOGGLE_PLP_FILTER]: function ({ /*commit,*/ dispatch, state }) {
    debug('%s payload %o', ACTION_TOGGLE_PLP_FILTER, !state.ui.plpLoadingFacets)
    // commit(UPDATE_UI, { plpLoadingFacets: !state.ui.plpLoadingFacets })
    dispatch(ACTION_TOGGLE_SIDEBAR)
  },
  [ACTION_TOGGLE_SIDEBAR]: function ({ commit, state }) {
    const sidebar = !state.ui.sidebar
    debug('%s action', ACTION_TOGGLE_SIDEBAR)
    commit(UPDATE_UI, { sidebar: sidebar })
    commit(UPDATE_UI_BODY, { overflow: sidebar ? 'hidden' : '' })
  },
  [ACTION_LOAD_MORE]: function (
    { dispatch, commit, state },
    { override, updateUi, clearUrl, ...payload }
  ) {
    debug('%s payload %o', ACTION_LOAD_MORE, payload)
    commit(UPDATE_FACETS, payload)
    dispatch(ACTION_LOAD_PLP_PRODUCTS, { override, updateUi, clearUrl, ...state.facetsSelected })
  },
 
  [ACTION_UPDATE_FILTER_CATEGORY_LABEL]: function ({ commit }, payload) {
    commit(UPDATE_FILTER_CATEGORY_LABEL, payload)
  },
  [ACTION_TOGGLE_FILTER_ITEM]: function ({ commit }, label) {
    debug('%s payload %o', ACTION_TOGGLE_FILTER_ITEM, label)
    commit(UPDATE_UI, { filterItemClicked: label })
  },
  [ACTION_UPDATE_IDS_FILTERS_CHECKED]: async function ({ commit, dispatch }, payload) {
    await commit(UPDATE_IDS_FILTERS_CHECKED, payload)
    await dispatch(ACTION_LOAD_PLP_FACETS)
  },
  [ACTION_REMOVE_FACET_COUNT]: function ({ commit }, id) {
    commit(UPDATE_REMOVE_FACET_COUNT, id)
  },
  [ACTION_UPDATE_FILTERED_CMS_BANNERS]: function ({ commit }, response) {
    commit(UPDATE_FILTERED_CMS_BANNERS, response)
  },
  [ACTION_ADD_REMOVE_FAVORITE]: function ({ commit }, params) {
    commit(UPDATE_ADD_REMOVE_FAVORITE, params)
  },
  [ACTION_RETRIEVE_FAVORITE_LIST]: async function ({ commit }, catentryId) {
    const wishlistItems = await getWishlistProducts()
    commit(UPDATE_RETRIEVE_FAVORITE_LIST, { wishlistItems, catentryId })
  },
}
